import React, { useContext } from "react";
import styled from "styled-components";
import { AppType } from "../../WSUtils/AppType";
import { device } from "../../WSUtils/constants/mediaQueries";
import { UserInfoContext } from "../../WSUtils/UserInfoContext";
import { concatClassnames } from "../../WSUtils/util";
import { routerStore, wsRouteMatch } from "../../WSUtils/WSRouter";
import SideBar, { sideMenuLgWidth, sideMenuXlWidth } from "../Nav/SideMenu";
import TopBar from "../Nav/TopBar";

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const userInfo = useContext(UserInfoContext);

  const isQuestionnairePage = wsRouteMatch(
    /^(\/webtemp-cvportal-frontend)?\/?questionnaire$/i,
    routerStore.location.pathname
  );

  const isAdminPage = wsRouteMatch(
    [/^\/?admin$/i, /^\/?admin\/.*/i],
    routerStore.location.pathname
  );

  const showFrame =
    userInfo.appType === AppType.cvWebtempNo &&
    !isQuestionnairePage &&
    !isAdminPage;

  const content = (
    <PageContent
      className={concatClassnames([
        "cvp-page-content",
        userInfo.appType === AppType.cvWebtempNo &&
          "cvp-page-content-cvwebtempno",
      ])}
    >
      {children}
    </PageContent>
  );

  if (!showFrame) return content;

  return (
    <>
      <PageContainer className="cvp-page-container">
        <TopBar />
        <SideBar />

        {content}
      </PageContainer>
    </>
  );
};
export default Layout;

export const PageContainer = styled.div`
  &.cvp-page-container {
    display: flex;
    min-height: 100vh;
    position: relative;
    padding-top: 3rem;

    .cvp-scrolling-element-into-view {
      // scroll offset - should be height of top bar
      scroll-margin-top: 3rem;
    }

    /* @media ${device.xl} {
      position: static;
    } */
  }
`;

export const PageContent = styled.div`
  &.cvp-page-content {
    display: flex;
    position: relative;
    display: flex;
    flex: 1 1 auto;
    flex-direction: column;

    &.cvp-page-content-cvwebtempno {
      padding: 1rem;
      max-width: 100%;
      min-height: 100vh;

      @media ${device.lg} {
        max-width: calc(100% - ${sideMenuLgWidth}px);
      }

      @media ${device.xl} {
        max-width: calc(100% - ${sideMenuXlWidth}px);
      }
    }

    .p-card {
      margin-bottom: 2rem;
    }

    @media ${device.xl} {
      padding: 2rem 2rem;
    }
  }
`;
